export class FieldConfigurationEdit
{
    public id = null;
    public name = '';
    public field = '';
    public type = '';
    public xpath = '';
    public section = '';
    public subSection = '';
    public codeSet: any;
    public active = true;
    public options: Array<FieldConfigurationEditOptions> = null;
}

export class FieldConfigurationEditOptions
{
    public rowId: number;
    public id: number;
    public name = '';
    public value = '';
    public codeSet: any;
}
